import moment from 'moment';
import React from 'react';
import { RenderCurrency, RenderDollar, RenderKilogramo } from './renderReadField';

/**
 * Para cambiar formato de fecha a DD/MM/YYYY
 * @param {*} date - fecha a formatear
 * @returns {string} - fecha formateada
 */
export const FormatDate = (date) => {
    return moment(date).format('DD/MM/YYYY')
}

/**
 * Para cambiar formato de fecha a YYYY-MM-DD
 * @param {*} date - fecha a formatear
 * @returns {string} - fecha formateada
 */
export const FormatDateTimeForDB = (date) => {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

// ___________ VALIDACIONES DE FORMULARIOS ___________
/**
 * Validación de campo requerido
 * @param {*} value - valor del campo
 * @returns {string|undefined} - mensaje de error o undefined si no hay error
 */
export const requiredField = value => (
    value !== undefined && value !== null && value !== ''
        ? undefined : 'Este campo es obligatorio'
);

/**
 * Validación de campo requerido para campos de tipo número
 * @param {*} value - valor del campo
 * @returns {string|undefined} - mensaje de error o undefined si no hay error
 */
export const positiveNumberField = value => value && isNaN(Number(value)) || Number(value) < 0 ? 'Debe ser número positivo' : undefined

/**
 * Validación de número entre 0 y 1
 * @param {*} value - valor del campo
 * @returns {string|undefined} - mensaje de error o undefined si no hay error
 */
export const between0and1Field = (value) => {
    if (value === undefined || value === null || value === "") {
        return "Este campo es obligatorio";
    }
    if (isNaN(value)) {
        return "Debe ser un número válido";
    }
    if (value < 0 || value > 1) {
        return "Debe estar entre 0 y 1";
    }
    return undefined; // No hay errores
};

// Cantidad máxima para los campos numéricos
export const maxFloatNumber = 99999999999999;

/**
 * Validación de campo numérico con máximo
 * @param {*} value - valor del campo
 * @returns {string|undefined} - mensaje de error o undefined si no hay error
 */
export const maxFloatField = value => value && isNaN(Number(value)) || Number(value) > maxFloatNumber ? 'Debe ser un número válido' : undefined

// ___________ FORMATO DE DATOS ___________
/**
 * Devuelve un campo numérico con formato de moneda o un string
 * @param {*} value - valor a formatear
 * @param {*} isDollar - si es dólar o no
 * @returns {string|JSX.Element} - valor formateado o string
 */
export const currencyValue = (value, isDollar = true) => {
    if (value === undefined || value === null) return '';

    // si no es numero
    if (typeof value !== 'number' || Number.isNaN(Number(value))) return value;

    if (isDollar) return <RenderDollar value={value} decimalScale={4} />
    return <RenderCurrency value={value} decimalScale={4} />
}

/**
 * Devuelve un campo numérico con formato de kilogramo o un string
 * @param {*} value - valor a formatear
 * @returns {string|JSX.Element} - valor formateado o string
 */
export const kgValue = (value) => {
    if (value === undefined || value === null) return '';
    // si no es numero
    if (typeof value !== 'number' || Number.isNaN(Number(value))) return value;
    return <RenderKilogramo value={value} />
}
